import i18n from '@/utils/i18n';
import React from 'react';
import { ItemDetailContentData } from '@/experiences/sales-portal/domain/items/blocs/types/item-detail-content';
import { ItemDetailSection } from '@/experiences/sales-portal/domain/items/components/item-detail-section';
import { ProductDescription } from '@/experiences/sales-portal/domain/items/components/details-tab/product-description';
import { YStack } from '@usepepper/sprout-kit-ui';

interface OrderEntryMobileDetailsTabProps {
  data: ItemDetailContentData;
}

export const OrderEntryMobileDetailsTab: React.FC<
  OrderEntryMobileDetailsTabProps
> = ({ data }) => {
  const description =
    data.saltInfo?.description?.trim() ||
    data.itemInfo.description?.trim() ||
    null;

  return (
    <YStack gap="$16">
      <ProductDescription description={description} />
      <ItemDetailSection
        content={{ kind: 'rows', rows: data.productSpecRows }}
        title={i18n.t(
          'sales_portal.order_entry.item_detail.product_specs.title',
        )}
      />
    </YStack>
  );
};
